import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { optimizeFontLoading } from "./utils/performanceOptimizer";
import { initializePixel } from "./utils/metaPixel";
import { AuthProvider } from "./contexts/AuthContext";

// Optimize font loading
optimizeFontLoading();

// Initialize Meta Pixel for Facebook Ads
initializePixel();

// Create root with concurrent mode
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render app with performance optimizations
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

// Report web vitals for performance monitoring
reportWebVitals((metric) => {
  // Log to console in development
  if (process.env.NODE_ENV === "development") {
    console.log(metric);
  }

  // In production, you can send to an analytics endpoint
  // Example: sending to Google Analytics
  if (process.env.NODE_ENV === "production") {
    // window.gtag('event', metric.name, {
    //   value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    //   event_category: 'Web Vitals',
    //   event_label: metric.id,
    // });
  }
});

// Register service worker for offline capabilities
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("SW registered: ", registration);
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  });
}
